// custom filter desktop and mobile script

document.addEventListener("DOMContentLoaded", function() {
  
  const collectionFilterSelector = '[js-collection-filter]';
  const collectionItemsSelector = '[js-collection-items]';
  const filterDesktopForm = '[js-cus-desktop-filter-form]';
  const filterMobileForm = '[js-cus-mobile-filter-form]';
  const filterItemWrapper = '[js-cus-product-filter]';
  const filterLableSelector = '[js-cus-filter-label]';
  const filterListSelector = '[js-cus-filter-list]';
  const filterOptionInput = '[js-cus-option-input]';
  const clearAllFiltersSelector = '[js-cus-clear-all-filters]';
  const activeFiltersSelector = '[js-cus-active-filters]';
  const removeFilterSelector = '[js-cus-active-filter-remove]';
  const collectionSelector = '[js-cus-collection]';

  const mobileFilterDrewerCTASelector = "[js-cus-drawer-cta]";
  const mobileFilterDrewerCloseCTASelector = "[js-cus-drawer-close-cta]";
  const filterDrewerSelector = "[js-cus-mobile-filter-drawer]";

  const filterAccordionSelector = "[js-cus-filter-accordion]";
  const filterAccordionHeaderSelector = "[js-cus-filter-accordion-header]";

  const mobileColorSwitcherWraperSelector = "[js-cus-mobile-color-switcher]";
  const desktopColorSwitcherWraperSelector = "[js-cus-desktop-color-switcher]";

  initFun();

  function removeFilterBaseOnDeviceWidth() { 
    if(window.innerWidth < 768){
      document.querySelector(filterDesktopForm).remove();
      document.querySelectorAll(desktopColorSwitcherWraperSelector).forEach(switcherWrapper => {
        switcherWrapper.remove();
      })
    } else {
      document.querySelector(filterMobileForm).remove();
      document.querySelectorAll(mobileColorSwitcherWraperSelector).forEach(switcherWrapper => {
        switcherWrapper.remove();
      })
    }
  }

  function replaceUrlHistory (url, query){
    if(query){
      url = `${url}?${query}`
    } else {
      url = `${url}`
    }
    window.history.pushState('','', url)
  }

  function fetchData(url, query){
    replaceUrlHistory(url, query)
    if(query){
      url = `${url}?view=ajax&${query}`
    } else {
      url = `${url}?view=ajax`
    }

    fetch(url)
      .then(response => {
        return response.text()
      })
      .then(doc => {
        const parser = new DOMParser()
        const html = parser.parseFromString(doc, 'text/html')
        
        const ajaxCollectionFilter = html.querySelector(collectionFilterSelector)
        document.querySelector(collectionFilterSelector).replaceWith(ajaxCollectionFilter)

        const ajaxCollectionItems = html.querySelector(collectionItemsSelector)
        document.querySelector(collectionItemsSelector).replaceWith(ajaxCollectionItems)
        
        removeFilterBaseOnDeviceWidth();

        document.dispatchEvent(new CustomEvent('renderBundleProduct:init'));

      })
  }

  function showActiveFilters(formData){
    document.querySelector(clearAllFiltersSelector).style.display = 'none';
    const activeFilters = [];
    const activeFilterWrapper = document.querySelector(activeFiltersSelector);
    activeFilterWrapper.innerHTML = '';
    for (const entry of formData.entries()) {
      if(entry[0] !== "sort_by"){
        activeFilters.push(entry[1]);
      }
    }

    activeFilters.reverse().forEach(item => {
      activeFilterWrapper.insertAdjacentHTML('afterbegin', `
        <div class="active-filter">
          <span class="filter-remove-cta" data-label="${item}" js-cus-active-filter-remove >
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
              <path d="M9.53564 2.9646L2.46458 10.0357" stroke="#EEEBE0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9.53542 10.0357L2.46436 2.9646" stroke="#EEEBE0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <span class="label">${item}</span>
      </div>`)

      if(activeFilters.length){
        document.querySelector(clearAllFiltersSelector).style.display = 'inline-block';
      }
      
    })

  }

  function collectionFilter(formTag){

    const formData = new FormData(document.querySelector(formTag))
    showActiveFilters(formData)

    const queryString = new URLSearchParams(formData).toString();
    const url = `${location.origin}${location.pathname}`

    fetchData(url, queryString)
  }

  function initFun(){
    removeFilterBaseOnDeviceWidth()
  }

  document.addEventListener('click', function(e){
    document.querySelectorAll(filterAccordionHeaderSelector).forEach(accordionHeader => {
      if(accordionHeader.contains(e.target)){
        const parent = accordionHeader.closest(filterAccordionSelector);
        if(parent.classList.contains('open')) {
          parent.classList.remove('open');
        } else {
          parent.classList.add('open');
        }
      }
    })

    const mobileFilterDrawerCta = document.querySelector(mobileFilterDrewerCTASelector);
    const mobileFilterDrewerCloseCTA = document.querySelector(mobileFilterDrewerCloseCTASelector);

    if(mobileFilterDrawerCta?.contains(e.target)){
      document.querySelector(filterDrewerSelector).classList.add('filter-open');
    }

    if(mobileFilterDrewerCloseCTA?.contains(e.target)){
      document.querySelector(filterDrewerSelector).classList.remove('filter-open');
    }

    document.querySelectorAll(collectionSelector).forEach(collection => {  
      if(collection.contains(e.target)) {

        document.querySelectorAll(collectionSelector).forEach(collection_ => {
          collection_.classList.remove('selected');
        })

        collection.classList.add('selected'); 

        let selectedSliderIndex = $('.collection_list_slider_new .selected').index();

        collection_list_slider_new.slideTo(selectedSliderIndex, 1000)

        const url = `${location.origin}${collection.getAttribute('data-collection-url')}`;
    
        fetchData(url)
      }
    })

    document.querySelectorAll(filterItemWrapper).forEach(filterItem => {
      if(!filterItem.contains(e.target)){
        filterItem.classList.remove('selected');
      }
    })

    document.querySelectorAll(filterLableSelector).forEach(filterLabel => {
      if(filterLabel.contains(e.target)){
        const parent = filterLabel.closest(filterItemWrapper);
        if(!parent.classList.contains('selected')) {
          parent.classList.add('selected');
        } else {
          parent.classList.remove('selected');
        }
      }
    })

    document.querySelectorAll(filterListSelector).forEach(filterList => {
      if(filterList.contains(e.target)){
        const parent = filterList.closest(filterItemWrapper);
        parent.classList.add('selected');
      }
    })

    document.querySelectorAll(removeFilterSelector).forEach(btn => {
      if(btn.contains(e.target)){
        document.querySelectorAll(filterOptionInput).forEach(input => {
          if(input.value == btn.getAttribute('data-label')) {
            input.checked = false;
            if(document.querySelector(filterDesktopForm)){
              collectionFilter(filterDesktopForm)
            } else {
              collectionFilter(filterMobileForm)
            }
          }
        })
      }
    })

    document.querySelectorAll(clearAllFiltersSelector).forEach(btn => {
      if(btn.contains(e.target)){
        document.querySelectorAll(filterOptionInput).forEach(filterInput => {
          if(filterInput.checked){
            filterInput.checked = false
          }
        })

        if(document.querySelector(filterDesktopForm)){
          collectionFilter(filterDesktopForm)
        } else {
          collectionFilter(filterMobileForm)
        }

      }
    })

    document.querySelectorAll(filterOptionInput).forEach(filterInput => {
      if(filterInput.contains(event.target)){
        if(document.querySelector(filterDesktopForm)){
          collectionFilter(filterDesktopForm)
        } else {
          collectionFilter(filterMobileForm)
        }
      }
    })
    
  })
});